import { b64LexDecode, b64LexEncode } from '../../common/b64lex.js';
export const arrayBufferTypeDef = {
    ArrayBuffer: {
        replace: (ab) => ({
            $t: 'ArrayBuffer',
            v: b64LexEncode(ab),
        }),
        revive: ({ v }) => {
            const ba = b64LexDecode(v);
            const buf = ba.buffer.byteLength === ba.byteLength
                ? ba.buffer
                : ba.buffer.slice(ba.byteOffset, ba.byteOffset + ba.byteLength);
            return buf;
        },
    },
};
export default arrayBufferTypeDef;
